import React from 'react';
// import { Form } from 'semantic-ui-react'

// const FactIFact1 = ({styles, handleChange, handleSubmit, args, handleClickRegr}) => {
const FactIFact1 = ({styles, handleClickRegr}) => {
  // if(args.contrato){
  //   var contrato = document.getElementById("contrato");
  //   if(contrato){contrato.value = args.contrato}
  // }
  // if(args.nombreCliente){
  //   var nombreCliente = document.getElementById("nombreCliente");
  //   if(nombreCliente){nombreCliente.value = args.nombreCliente}
  // }
  // if(args.apellidoCliente){
  //   var apellidoCliente = document.getElementById("apellidoCliente");
  //   if(apellidoCliente){apellidoCliente.value = args.apellidoCliente}
  // }
  // if(args.descrDpto){
  //   var descrDpto = document.getElementById("descrDpto");
  //   if(descrDpto){descrDpto.value = args.descrDpto}
  // }
  // if(args.nombreCiudad){
  //   var nombreCiudad = document.getElementById("nombreCiudad");
  //   if(nombreCiudad){nombreCiudad.value = args.nombreCiudad}
  // }
  // if(args.nombreZona){
  //   var nombreZona = document.getElementById("nombreZona");
  //   if(nombreZona){nombreZona.value = args.nombreZona}
  // }
  // if(args.nombreBarrio){
  //   var nombreBarrio = document.getElementById("nombreBarrio");
  //   if(nombreBarrio){nombreBarrio.value = args.nombreBarrio}
  // }

  return (
    <div>
      {/* <Form onSubmit={(ev)=>handleSubmit(ev, args)}> */}
        <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
          <i className="large sitemap yellow icon"></i>
          Opciones
        </button>
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
          <i className="large arrow left violet icon"></i>
          Regresar
        </button>

        {/* <Divider inverted />

        <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
          <i className="large search yellow icon"></i>
          Buscar
        </button>
        <div className="ui input fluid">
          <input id='contrato' autoComplete="off" name="contrato" type="text" placeholder="Contrato" autoFocus style={styles.dropdown} onChange={handleChange}/>
        </div>
        <div className="ui input fluid">
          <input id='nombreCliente' autoComplete="off" name="nombreCliente" type="text" placeholder="Nombre(s)" style={styles.dropdown} onChange={handleChange}/>
        </div>
        <div className="ui input fluid">
          <input id='apellidoCliente' autoComplete="off" name="apellidoCliente" type="text" placeholder="Apellido(s)" style={styles.dropdown} onChange={handleChange}/>
        </div>
        <div className="ui input fluid">
          <input id='descrDpto' autoComplete="off" name="descrDpto" type="text" placeholder="Departamento" style={styles.dropdown} onChange={handleChange}/>
        </div>
        <div className="ui input fluid">
          <input id='nombreCiudad' autoComplete="off" name="nombreCiudad" type="text" placeholder="Ciudad" style={styles.dropdown} onChange={handleChange}/>
        </div>
        <div className="ui input fluid">
          <input id='nombreZona' autoComplete="off" name="nombreZona" type="text" placeholder="Zona" style={styles.dropdown} onChange={handleChange}/>
        </div>
        <div className="ui input fluid">
          <input id='nombreBarrio' autoComplete="off" name="nombreBarrio" type="text" placeholder="Barrio" style={styles.dropdown} onChange={handleChange}/>
        </div> */}
      {/* </Form> */}
    </div>
  )
};

export default FactIFact1
